import { getWrapTokensAPI } from "../../server/swap";
import { getCurrencyAPI } from "../../server/walletManage";

export const getWrapTokensWithCurrency = async (args?: {
  query: {
    wrapTokenIdList?: number[];
    microChainId?: number;
    contractAddress?: string;
    ownerMicroChainId?: number;
    ownerMicroChainCurrencyId?: number;
  };
}) => {
  const wrapTokens = await getWrapTokensAPI.request(args);
  const wrapTokenIds = wrapTokens.map(
    (wrapToken) => wrapToken.ownerMicroChainCurrencyId
  );
  const currencies = await getCurrencyAPI.request({
    query: {
      microChainCurrencyIds: wrapTokenIds,
    },
  });

  const wrapTokensWithCurrency = wrapTokens.map((wrapToken) => {
    const currency = currencies.find(
      (currency) =>
        currency.microChainCurrencyId === wrapToken.ownerMicroChainCurrencyId
    );
    return {
      ...wrapToken,
      currency,
    };
  });

  return wrapTokensWithCurrency;
};
